import { Box } from 'reflexbox';

import { Skeleton } from '@treams/treams-ui';

export const SelectConversationTypeCardSkeleton = () => {
	return (
		<>
			<Box pt={3}>
				<Skeleton.Box height={50} />
			</Box>
			<Box pt={1}>
				<Skeleton.Box height={50} />
			</Box>
			<Box pt={1}>
				<Skeleton.Box height={50} />
			</Box>
			<Box pt={1}>
				<Skeleton.Box height={50} />
			</Box>
		</>
	);
};
